import SettingsUserMasterfile from "Components/Features/SettingsUserMasterfile"
import React from "react"

function SettingsUserMasterfilePage() {
  return <SettingsUserMasterfile />
}

export default SettingsUserMasterfilePage
